import type { Enums } from "@/integrations/supabase/types";

type CourtType = Enums<"court_type">;

/** Read max_players directly from court object, fallback to court_type */
export function getMaxPlayers(court: { max_players?: number; court_type?: string } | null | undefined): number {
  if (court?.max_players) return court.max_players;
  return getMaxPlayersByCourtType(court?.court_type as any);
}

/** @deprecated Use getMaxPlayers(court) instead */
export function getMaxPlayersByCourtType(courtType: CourtType | undefined | null): number {
  switch (courtType) {
    case "single":
      return 2;
    case "double":
    case "panorama":
      return 4;
    default:
      return 4;
  }
}

export function getCourtTypeLabel(courtType: string | undefined | null): string {
  const labels: Record<string, string> = {
    single: "Singel",
    double: "Dubbel",
    panorama: "Panorama",
    standard: "Standard",
    indoor: "Inomhus",
    outdoor: "Utomhus",
  };
  return labels[courtType ?? ""] ?? courtType ?? "Standard";
}
